module.exports = __webpack_public_path__ + "img/BS31.5edc8ffc.svg";